import { render, staticRenderFns } from "./RealTimeAlarm.vue?vue&type=template&id=24cae95c&scoped=true"
import script from "./RealTimeAlarm.vue?vue&type=script&lang=js"
export * from "./RealTimeAlarm.vue?vue&type=script&lang=js"
import style0 from "./RealTimeAlarm.vue?vue&type=style&index=0&id=24cae95c&prod&lang=scss"
import style1 from "./RealTimeAlarm.vue?vue&type=style&index=1&id=24cae95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cae95c",
  null
  
)

export default component.exports